import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const headers = new HttpHeaders().set("Content-Type", "application/json");
const httpOptions2 = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'AccessLicenseNumber': '6D26AC12326516D6',
        'transId': '12345',
        'transactionSrc': 'P9'
    })
};

@Injectable()
export class UpplmApiService {
   
    constructor(@Inject(HttpClient) private httpclient: HttpClient) {

    }

    PostServiceAPI(apiurl, body): Observable<any> {
        let _body = JSON.stringify(body);
        let url = apiurl;
        return this.httpclient.post<any>(url, _body, httpOptions);
    }

    PostServiceAPIObject(apiurl, body: object): Observable<any> {
        let _body = JSON.stringify(body);
        let url = apiurl;
        return this.httpclient.post<any>(url, _body, httpOptions);
    }

    PostUploadServiceAPI(apiurl, body): Observable<any> {
        let _body = body;
        let url = apiurl;
        return this.httpclient.post<any>(url, _body);
    }

    executeWEMS(apiUrl: string, bodyData: object): Observable<any> {
        let body = JSON.stringify(bodyData);
        return this.httpclient.post(apiUrl, body, httpOptions);
    }

     getCatalogData(url: string) {
         return this.httpclient.get(url, httpOptions2);
    }       
}